import type { HTMLAttributes, ReactNode } from 'react';
import { clsx } from '../clsx';
import { Eyebrow } from './Eyebrow';
import styles from './EmptyState.module.css';

export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  /** Tool or module name above the headline ("Tickets", "Dialer"). */
  eyebrow?: ReactNode | undefined;
  title: ReactNode;
  description?: ReactNode | undefined;
  /** One primary and one secondary button. */
  actions?: ReactNode | undefined;
  /** Small note under a hairline ("Der Antrag erscheint als Freigabe-Task bei A. Brandl."). */
  footnote?: ReactNode | undefined;
  /** `card`: the 560 px card of Shell 13/14 (left-aligned text); `centered`: the full-width centred card ("Alles erledigt."). */
  variant?: 'card' | 'centered' | undefined;
}

/** Empty, locked and "all done" states with first-use value. */
export function EmptyState({
  eyebrow,
  title,
  description,
  actions,
  footnote,
  variant = 'card',
  className,
  ...rest
}: EmptyStateProps) {
  return (
    <div className={clsx(styles.card, variant === 'centered' && styles.centered, className)} {...rest}>
      {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
      <div className={clsx(styles.title, Boolean(eyebrow) && styles.titleAfterEyebrow)}>{title}</div>
      {description ? <div className={styles.description}>{description}</div> : null}
      {actions ? <div className={styles.actions}>{actions}</div> : null}
      {footnote ? <div className={styles.footnote}>{footnote}</div> : null}
    </div>
  );
}
